export function heatMap3DTriangulation(width, height) {
  var indices = [];
  var vertices = [];
  var uvs = [];
  var gridX1 = width + 1;
  var gridY1 = height + 1;
  var widthHalf = width / 2;
  var heightHalf = height / 2;

  for (var iy = 0; iy < gridY1; iy++) {
    var y = iy - heightHalf;

    for (var ix = 0; ix < gridX1; ix++) {
      var x = ix - widthHalf;
      vertices.push(x / widthHalf, -y / heightHalf, 0);
      uvs.push(ix / width);
      uvs.push(1 - iy / height);
    }
  }

  for (var _iy = 0; _iy < height; _iy++) {
    for (var _ix = 0; _ix < width; _ix++) {
      var a = _ix + gridX1 * _iy;
      var b = _ix + gridX1 * (_iy + 1);
      var c = _ix + 1 + gridX1 * (_iy + 1);
      var d = _ix + 1 + gridX1 * _iy;
      indices.push(a, b, d);
      indices.push(b, c, d);
    }
  }

  return {
    vertices: vertices,
    indices: indices,
    uvs: uvs
  };
}